<template>
  <div
    :style="getStyle()"
    class="sc-map-popup"
    v-if="settings && settings.layer_id"
  >
    <div class="sc-map-popup__col" v-if="settings.icons && settings.colors">
      <r-cblock :size="28" :color="getColor()">
        <r-icon :name="getIcon()" :size="20" :color="getColor()" />
      </r-cblock>
    </div>
    <div class="sc-map-popup__col">
      <div class="sc-map-popup__title">
        <r-title type="subtitle-1">{{ $t(settings.layer_id) }}</r-title>
      </div>
      <ul
        class="sc-map-popup__list"
        v-if="settings.values && settings.values.length"
      >
        <li
          v-for="item in settings.values"
          :key="item.key"
          class="sc-map-popup__item"
        >
          <r-text type="caption" v-if="item.key !== `pdk_cams`">
            {{ $t(item.key) }}
          </r-text>
          <r-text v-if="item.value && item.key === `avg_speed`">
            {{ $t(item.value) }} {{ $t(`km/h`) }}
          </r-text>
          <r-text v-if="item.value && item.key === `distance`">
            {{ $t(item.value) }} {{ $t(`m`) }}
          </r-text>
          <r-text
            v-if="
              item.key !== `pdk_cams` &&
                item.key !== `distance` &&
                item.key !== `avg_speed`
            "
          >
            {{
              item.value || item.value === false ? $t(String(item.value)) : "-"
            }}
          </r-text>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    settings: {
      type: Object,
      required: true,
      default: () => null
    }
  },
  methods: {
    getStyle() {
      const display = this.settings.display;
      const top = this.settings.top;
      const left = this.settings.left;

      return `display:${display};top:${top}px;left:${left}px`;
    },
    getColor() {
      let statusValues;
      let type = "";
      let pdkCams = [];
      let cams = [];

      switch (this.settings.layer_id) {
        case "chsmeo_traffic_light":
        case "tagil_traffic_light?format=from_service":
          statusValues = this.settings.values.find(e => e.key === "mode");
          type = statusValues.value === "нет ошибок" ? "work" : "error";
          break;
        case "chsmeo_cams":
          statusValues = this.settings.values.find(e => e.key === "pdk_cams");
          pdkCams = JSON.parse(statusValues.value);
          type = !pdkCams.length
            ? "inactive"
            : pdkCams.some(n => !n.status)
            ? "error"
            : "work";
          break;
        case "chsmeo_cams_kps":
          statusValues = this.settings.values.find(e => e.key === "pdk_cams");
          cams = JSON.parse(statusValues.value);
          type = !cams.length
            ? "inactive"
            : cams.some(n => !n.status)
            ? "error"
            : "work";
          break;
        case "chsmeo_meteo_data?format=from_service":
          statusValues = this.settings.values.find(e => e.key === "status");
          type = statusValues.value ? "work" : "error";
          break;
        case "TagilDetector":
          statusValues = this.settings.values.find(e => e.key === "status");
          type = statusValues.value ? "work" : "error";
          break;
        case "TagilPublicTransport?format=dit":
          statusValues = this.settings.values.find(e => e.key === "status");
          type = statusValues.value ? "work" : "error";
          break;
        default:
          type = this.settings.type || "default";
          break;
      }

      return this.settings.colors[type] || this.settings.colors.default;
    },
    getIcon() {
      const type = this.settings.type === 2 ? "default" : this.settings.type;
      return this.settings.icons[type] || this.settings.icons.default;
    }
  }
};
</script>

<style lang="scss">
.sc-map-popup {
  max-width: 360px;
  position: absolute;
  border-radius: var(--border-radius);
  background-color: var(--bg_panel_primary) !important;
  color: var(--text_primary) !important;
  min-width: 120px;
  padding: 16px 12px;
  box-shadow: 0px 3px 6px rgba(var(--black), 0.4);
  display: flex;
  justify-content: space-between;
  z-index: 10;
  &__col {
    width: 60px;
    overflow: hidden;
    &:last-child {
      width: calc(100% - 60px);
      text-align: start;
    }
  }

  &__item {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    div {
      text-align: end;
      text-overflow: unset;
      &:first-child {
        flex-shrink: 0;
        margin-right: 8px;
      }
    }
  }

  &__key {
    margin-right: 16px;
  }
  &__value {
    font-weight: bold;
  }
}
.r_medium {
  .sc-map-popup {
    max-width: 280px;
    min-width: 120px;
    &__col {
      width: 50px;
      &:last-child {
        width: calc(100% - 50px);
      }
    }

    &__item {
      div {
        text-align: end;
        &:first-child {
          margin-right: 8px;
        }
      }
    }

    &__key {
      margin-right: 12px;
    }
  }
}
</style>

<i18n>
{
  "ru": {
    "events": "События",
    "true": "Работает",
    "false": "Не работает",
    "location": "Адрес",
    "type": "Тип",
    "code": "Код",
    "phase": "Фаза",
    "status": "Статус",
    "mode": "Мод",
    "report": "Отчет",
    "voltage": "Вольтаж",
    "reg_number": "Рег.номер",
    "organization": "Организация",
    "event_class": "Тип события",
    "ДТП": "ДТП",
    "Мероприятия": "События",
    "Ремонтные работы": "Дорожные работы",
    "contractor": "Контрактор",
    "contact": "Контакт",
    "contract": "Контракт",
    "period": "Период",
    "object_id": "ИД объекта",
    "track_layer": "Трек",
    "avg_speed": "Средняя скорость",
    "distance": "Расстояние",
    "km/h": "км/ч",
    "m": "км",
    "to_time": "Время, до",
    "from_time": "Время, с"
  },
  "en": {
    "events": "Events",
    "true": "Work",
    "false": "Error",
    "location": "Address",
    "type": "Type",
    "code": "Code",
    "phase": "Phase",
    "status": "Status",
    "mode": "Mode",
    "report": "Report",
    "voltage": "Voltage",
    "reg_number": "Reg.number",
    "organization": "Organization",
    "event_class": "Event type",
    "ДТП": "Accident",
    "Мероприятия": "Event",
    "Ремонтные работы": "Road work",
    "contractor": "Contractor",
    "contact": "Contact",
    "contract": "Contract",
    "period": "Period",
    "object_id": "Object ID",
    "track_layer": "Track",
    "avg_speed": "Average speed",
    "distance": "Distance",
    "km/h": "km/h",
    "m": "km",
    "to_time": "To",
    "from_time": "From"
  }
}
</i18n>
